import { render, staticRenderFns } from "./singleCustomer.vue?vue&type=template&id=fe4a111a&scoped=true&"
import script from "./singleCustomer.vue?vue&type=script&lang=js&"
export * from "./singleCustomer.vue?vue&type=script&lang=js&"
import style0 from "./singleCustomer.vue?vue&type=style&index=0&id=fe4a111a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4a111a",
  null
  
)

export default component.exports